import { PersonIdKortStatus } from "../../../../interfaces/schema";
import { idKortStatusTekst } from "../../../../util/person";

const badgeClassNames: Record<PersonIdKortStatus, string> = {
  [PersonIdKortStatus.Bestilt]: "badge badge--fixed-size badge-blue",
  [PersonIdKortStatus.Behandlet]: "badge badge--fixed-size badge-green",
};

/**
 * Statusmærket for én ID-kort-bestilling — Status-kolonnen i IdKortHistorik. Teksten kommer fra
 * idKortStatusTekst, så mærket og Hent-eksporten ikke kan komme til at sige hver sit; her ligger
 * kun farven.
 */
const PersonIdKortStatusBadge = ({
  status,
}: {
  status: PersonIdKortStatus;
}) => {
  const label = `ID-kort: ${idKortStatusTekst(status)}`;

  return (
    <span className={badgeClassNames[status]} aria-label={label}>
      {label}
    </span>
  );
};

export default PersonIdKortStatusBadge;
